import React from "react";
import "./Spacer.scss";

function Spacer() {
	return <div className="Spacer" />;
}

export default Spacer;
